// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD4Txm43xPpNCLO8LG9DKXIpVm_rNDLqYA",
  authDomain: "t-alento.firebaseapp.com",
  projectId: "t-alento",
  storageBucket: "t-alento.firebasestorage.app",
  messagingSenderId: "338171604283",
  appId: "1:338171604283:web:1410ecb01ec675d7009b1e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);

// Initialize Firebase Storage
export const storage = getStorage(app);

export default app;
